<script setup lang="ts">
defineProps({
  showTooltip: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <div class="relative w-5 h-[18px]">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="peer">
      <mask
        id="mask0_801_143"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_801_143)">
        <path
          d="M17.2998 5.2002L20.9004 6L20.5498 9.7002L23 12.5L20.5498 15.2998L20.9004 19L17.2998 19.7998L15.4004 23L12 21.5498L8.59961 23L6.7002 19.7998L3.09961 19L3.4502 15.2998L1 12.5L3.4502 9.7002L3.09961 6L6.7002 5.2002L8.59961 2L12 3.4502L15.4004 2L17.2998 5.2002ZM7.33398 12.3359C7.33398 13.5026 7.71222 14.5246 8.46777 15.4023C9.22331 16.2801 10.1785 16.7966 11.334 16.9521V19.0029H12.667V16.9521C13.8225 16.7966 14.7786 16.2801 15.5342 15.4023C16.2896 14.5246 16.667 13.5025 16.667 12.3359H15.334C15.334 13.2581 15.0093 14.0444 14.3594 14.6943C13.7095 15.3443 12.9231 15.6689 12.001 15.6689C11.0788 15.6689 10.2925 15.3442 9.64258 14.6943C8.99258 14.0443 8.66699 13.2582 8.66699 12.3359H7.33398ZM12.001 6.33594C11.4455 6.33594 10.9728 6.53016 10.584 6.91895C10.1951 7.30783 10.001 7.78038 10.001 8.33594V12.3359C10.001 12.8915 10.1951 13.364 10.584 13.7529C10.9728 14.1417 11.4455 14.3359 12.001 14.3359C12.5562 14.3359 13.0282 14.1415 13.417 13.7529C13.8059 13.364 14.001 12.8915 14.001 12.3359V8.33594C14.001 7.78038 13.8059 7.30783 13.417 6.91895C13.0282 6.53035 12.5562 6.33601 12.001 6.33594Z"
          fill="#1C82CF" />
      </g>
    </svg>
    <CommonTooltip v-if="showTooltip">
      <template #tooltip-text>
        <p class="text-xs text-black font-semibold">
          {{ $t("main.influencerBadge.tooltip") }}
        </p>
      </template>
    </CommonTooltip>
  </div>
</template>
